// import apiConfig from "../config/apiConfig";
// // import { User } from "../context/LoginContext";

// export type User = {
//   username: string;
//   password: string;
// };

// export type UserRegistration = {
//   newUsername: string;
//   newPassword: string;
//   newFirstName: string;
//   newLastName: string;
//   newEmail: string;
//   adminUsername: string;
//   adminPassword: string;
//   resource: string;

//   user_name: string;
//   user_email: string;
// };
// const getCookie = (name: string): string | null => {
//     const value = `; ${document.cookie}`;
//     const parts = value.split(`; ${name}=`);
//     if (parts.length === 2) return parts.pop()?.split(";").shift() || null;
//     return null;
//   };
// export const login = async (user: User) => {
//   try {
//     const { username, password } = user;
//     const params = new URLSearchParams({
//       username: username,
//       password: password,
//     });

//      const loginData = {
//       username: username,
//       password: password,
//     }
//     const response = await fetch(
//       `${apiConfig.API_BASE_URL}/auth/login`,
//       {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//         },
//         body: JSON.stringify(loginData),
//         credentials: "include", // to receive cookies
//       },
//     );

//     if (!response.ok) {
//       throw new Error(`HTTP error! Status: ${response.status}`);
//     }

//     console.log("Cookies received:", document.cookie);

//     let data = null;
//     const text = await response.text();

//     if (text) {
//       data = JSON.parse(text); // only parse if body is not empty
//       console.log("Login response body:", data);
//     } else {
//       console.log("No response body received");
//     }

//     return true;
//   } catch (error) {
//     console.error("Login failed:", error);
//     return false;
//   }
// };


// export const logout = async () => {
//   try {



//     const response = await fetch(
//       `${apiConfig.API_BASE_URL}/auth/logout`,
//       {
//         method: "POST",
//        credentials: "include",
//       },
//     );

//     if (!response.ok) {
//       throw new Error(`HTTP error! Status: ${response.status}`);
//     }

//     return true;
//   } catch (error) {
//     console.error("Logout failed:", error);
//     return false;
//   }
// };
// export const registration = async (user:UserRegistration) => {
//   try {
//     // const {} = user;
//     const params = new URLSearchParams({
//       newUsername: user.newUsername,
//       newPassword: user.newPassword,
//       newFirstName: user.newFirstName,
//       newLastName: user.newLastName,
//       newEmail: user.newEmail,
//       adminUsername: user.adminUsername,
//       adminPassword: user.adminPassword,
//       resource: user.resource,
//     });
//     const userToSave = {
//       "user_name": user.user_name,
//       "user_email": user.newEmail,
//     };

//     const response = await fetch(
//       `${apiConfig.API_BASE_URL}/auth/add_user?${params.toString()}`,
//       {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//         },
//         body: JSON.stringify(userToSave),
//         credentials: "include", // important to receive cookies from backend
//       }
//     );
//     if (!response.ok) {
//       throw new Error(`HTTP error! Status: ${response.status}`);
//     }

//     // Optional: handle body if server also returns JSON
//     // const data = await response.json();
//     // console.log("Registration response body:", data);
//     console.log("Registration successful");
//     return true; // or return any meaningful info
//   } catch (error) {
//     console.error("Registration failed:", error);
//     return false;
//   }
// };

// export const assignClientRole = async (role: string) => {
//   try {
//     const accessToken = getCookie("access_token");

//     if (!accessToken) {
//       throw new Error("Access token not found");
//     }

//     const params = new URLSearchParams({
//       roleName: role,
//     });

//     const response = await fetch(
//       `${apiConfig.API_BASE_URL}/auth/add-client-role?${params.toString()}`,
//       {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//           "Authorization": `Bearer ${accessToken}`, // include the token here
//         },
//         credentials: "include", // include cookies if needed
//       }
//     );

//     if (!response.ok) {
//       throw new Error(`HTTP error! Status: ${response.status}`);
//     }

//     console.log("Role Assigned successfully");

//     return true;
//   } catch (error) {
//     console.error("Assign Role failed:", error);
//     return false;
//   }
// };
// export const userResourceRoleMapping = async (data: any) => {
//   try {
//     const accessToken = getCookie("access_token");

//     if (!accessToken) {
//       throw new Error("Access token not found");
//     }

//     const params = new URLSearchParams({
//       role: data.role,
//       userName: data.userName,
//       resourceType: data.resourceType,
//       resourceId: data.resourceId,
//     });

//     const response = await fetch(
//       `${apiConfig.API_BASE_URL}/auth/user_resource_role?${params.toString()}`,
//       {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//           "Authorization": `Bearer ${accessToken}`, // include token here
//         },
//         credentials: "include", // important to receive cookies from backend
//       }
//     );

//     if (!response.ok) {
//       throw new Error(`HTTP error! Status: ${response.status}`);
//     }

//     // Optional: handle body if server also returns JSON
//     // const data = await response.json();
//     console.log("User Resource Role Mapping successful");

//     return true; // or return any meaningful info
//   } catch (error) {
//     console.error("User Resource Role Mapping failed:", error);
//     return false;
//   }
// };


import { NavigateFunction, useNavigate } from "react-router-dom";
import apiConfig from "../config/apiConfig";
import { apiFetch } from "./apiFetch";

/* =======================
   TYPES
======================= */

export type User = {
  username: string;
  password: string;
};

/* ---------- OLD (LEGACY) REGISTRATION ---------- */
export type UserRegistration = {
  newUsername: string;
  newPassword: string;
  newFirstName: string;
  newLastName: string;
  newEmail: string;
  adminUsername: string;
  adminPassword: string;
  resource: string;
  user_name: string;
  user_email: string;
};

/* ---------- NEW ADD USER (JSON BODY) ---------- */
export interface AddUserRequest {
  resourceName: string;
  authMap: {
    userName: string;
    email: string;
    firstName: string;
    lastName: string;
    password: string;
  };
  resourceMap: {
    user_name: string;
    user_email: string;
    mobile_number: string;
  };
}

/* =======================
   HELPERS
======================= */

/* =======================
   ATOMIC REGISTER (OTP + User Creation)
======================= */

export const login = async (user: User): Promise<{ email: string; role: string; accessToken?: string }> => {
  const response = await fetch(
    `${apiConfig.API_BASE_URL}/auth/login`,
    {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(user),
      credentials: "include", // ensures cookies are sent/received cross-origin
    }
  );

  if (!response.ok) {
    const errorText = await response.text();
    throw new Error(errorText || `HTTP error! Status: ${response.status}`);
  }

  // Backend returns { email, role } in body (tokens are in HttpOnly cookies)
  const data = await response.json();
  // console.log("Login response data:", data);
  return data as { email: string; role: string };
};

export const refreshToken = async () => {
  const response = await fetch(
    `${apiConfig.API_BASE_URL}/auth/refresh`,
    {
      method: "POST",
      credentials: "include",
    }
  );

  if (!response.ok) {
    throw new Error("Refresh failed");
  }

  return true;
};

export const logout = async (navigate: NavigateFunction) => {
  try {
    await fetch(`${apiConfig.API_BASE_URL}/auth/logout`, {
      method: "POST",
      credentials: "include",
    });
  } catch (error) {
    console.error("Logout API failed:", error);
  }

  // Always clear local session
  localStorage.removeItem("user");
  localStorage.removeItem("isLoggedIn");

  navigate("/");
};

/* =======================
   OLD REGISTRATION (KEEP)
======================= */

export const registration = async (user: UserRegistration) => {
  try {
    const params = new URLSearchParams({
      newUsername: user.newUsername,
      newPassword: user.newPassword,
      newFirstName: user.newFirstName,
      newLastName: user.newLastName,
      newEmail: user.newEmail,
      adminUsername: user.adminUsername,
      adminPassword: user.adminPassword,
      resource: user.resource,
    });

    const userToSave = {
      user_name: user.user_name,
      user_email: user.user_email,
    };

    const response = await fetch(
      `${apiConfig.API_BASE_URL}/auth/add_user?${params.toString()}`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(userToSave),
        credentials: "include",
      }
    );

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    return true;
  } catch (error) {
    console.error("Registration failed:", error);
    return false;
  }
};

/* =======================
   NEW ADD USER (JSON BODY)
======================= */

export const addUser = async (data: AddUserRequest) => {
  const response = await fetch(
    `${apiConfig.API_BASE_URL}/auth/add_user`,
    {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
      credentials: "include",
    }
  );

  if (!response.ok) {
    // Try to get error message from response body
    let errorMessage = `Registration failed. Status: ${response.status}`;
    try {
      const errorData = await response.text();
      if (errorData) {
        // Check for common duplicate user error messages
        if (errorData.toLowerCase().includes("already exists") ||
          errorData.toLowerCase().includes("duplicate") ||
          errorData.toLowerCase().includes("user exists") ||
          errorData.toLowerCase().includes("email exists") ||
          response.status === 409) {
          errorMessage = "This email is already registered. Please use a different email or login with your existing account.";
        } else {
          errorMessage = errorData;
        }
      }
    } catch {
      // If parsing fails, use default message
    }
    throw new Error(errorMessage);
  }

  return true;
};

/* =======================
   ATOMIC REGISTER (OTP + User Creation)
======================= */

export interface RegisterWithOtpRequest {
  email: string;
  otp: string;
  resourceName: string;
  authMap: {
    userName: string;
    email: string;
    firstName: string;
    lastName: string;
    password: string;
  };
  resourceMap: {
    user_name: string;
    user_email: string;
    mobile_number: string;
    qualification?: string;
  };
}

export const registerWithOtp = async (data: RegisterWithOtpRequest, role: string) => {
  const response = await fetch(
    `${apiConfig.API_BASE_URL}/auth/register?role=${encodeURIComponent(role)}`,
    {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
      credentials: "include",
    }
  );

  if (!response.ok) {
    let errorMessage = `Registration failed. Status: ${response.status}`;
    try {
      const errorData = await response.text();
      if (errorData) {
        errorMessage = errorData;
      }
    } catch {
      // If parsing fails, use default message
    }
    throw new Error(errorMessage);
  }

  return true;
};

/* =======================
   ROLE APIs
======================= */

export const assignClientRole = async (role: string) => {
  try {
    const params = new URLSearchParams({ roleName: role });

    const response = await apiFetch(
      `${apiConfig.API_BASE_URL}/auth/add-client-role?${params.toString()}`,
      {
        method: "POST",
      }
    );

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    return true;
  } catch (error) {
    console.error("Assign Role failed:", error);
    return false;
  }
};

export const userResourceRoleMapping = async (data: any) => {
  try {
    const params = new URLSearchParams({
      role: data.role,
      userName: data.userName,
      resourceType: data.resourceType,
      resourceId: data.resourceId,
    });

    const response = await apiFetch(
      `${apiConfig.API_BASE_URL}/auth/user_resource_role?${params.toString()}`,
      {
        method: "POST",
      }
    );

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    return true;
  } catch (error) {
    console.error("User Resource Role Mapping failed:", error);
    return false;
  }
};

/* =======================
   FORGOT / RESET PASSWORD APIs
======================= */

export const forgotPassword = async (email: string): Promise<string> => {
  const params = new URLSearchParams({ email });
  const response = await fetch(
    `${apiConfig.API_BASE_URL}/auth/forgot-password?${params.toString()}`,
    {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      credentials: "include",
    }
  );

  const text = await response.text();
  if (!response.ok) {
    throw new Error(text || "Failed to send OTP.");
  }
  return text;
};

export const resetPassword = async (
  email: string,
  otp: string,
  newPassword: string
): Promise<string> => {
  const params = new URLSearchParams({ email, otp, newPassword });
  const response = await fetch(
    `${apiConfig.API_BASE_URL}/auth/reset-password?${params.toString()}`,
    {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      credentials: "include",
    }
  );

  const text = await response.text();
  if (!response.ok) {
    throw new Error(text || "Failed to reset password.");
  }
  return text;
};

